import React, { Component } from 'react'
import Select from 'react-select'
import { main_url, validate, stopSaving, startSaving, alertText } from '../../../utils/CommonFunction';
import { ToastContainer, toast } from 'react-toastify';
import { getHeaders } from '../../../utils/apiHelper';

var form_validate = true;

class DesignationEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data
        }
    }

    componentDidUpdate() {
        if (!form_validate) validate('check_form')
    }

    handleInputChange = (e) => {
        const obj = { ...this.state.data };
        obj[e.target.id] = e.target.value;
        this.setState({
            data: obj
        })
    }
    handleSelectorChange = (val, key) => {
        const obj = { ...this.state.data };
        obj[key] = val ? val.value : -1;
        if (key === 'staff_category_id') {
            obj.staff_category_name = val ? val.label : '';
        }
        this.setState({
            data: obj
        })
    }
    handleCheckChange = (e) => {
        const id = e.target.id;
        const val = e.target.checked ? 1 : 0;
        const obj = { ...this.state.data };
        obj[id] = val;
        this.setState({
            data: obj
        })
    }
    handleSave = () => {

        // stopSaving();
        if (validate('check_form')) {
            const { data } = this.state;
            let status = 0;
            fetch(`${main_url}Designation/editDesignation/${data.designations_id}`, {
                method: "POST",
                headers: getHeaders(true),
                body: `data=${JSON.stringify(data)}`

            })
                .then(res => {
                    status = res.status;
                    return res.text()
                })
                .then(text => {
                    this.props.showToast(status, text);
                })
        } else {
            toast.error(alertText, {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
            startSaving();
            form_validate = false;
        }
    }
    render() {
        const { department_type_option, level_options, staff_category_options } = this.props;
        const { data } = this.state;
        const selectedDepartmentType = (department_type_option.find(v => v.value == data.departments_id));
        const selectedAllowLevel = level_options.find(v => Number(v.career_level_id) === Number(data.career_level_id));
        const selectedStaffCategory = staff_category_options.find(v => Number(v.value) === Number(data.staff_category_id));
        return (
            <div className="container" style={{ marginTop: 20 }}>
                <div className='row'>
                    <form id="check_form">
                        <div className="row">
                            <div className="form-group col-md-4">
                                <div><label htmlFor="designations" className="col-sm-12">Designation</label></div>
                                <div className="col-sm-12">
                                    <input
                                        type="text"
                                        id='designations'
                                        className="form-control checkValidate"
                                        value={data.designations}
                                        onChange={this.handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="form-group col-md-4">
                                <div><label htmlFor="career_level_id" className="col-sm-12">Level</label></div>
                                <div className="col-sm-12">
                                    <Select
                                        placeholder="Please Choose Level"
                                        options={level_options}
                                        onChange={(val) => this.handleSelectorChange(val, 'career_level_id')}
                                        value={selectedAllowLevel}
                                        className='react-select-container  checkValidate'
                                        classNamePrefix="react-select" />
                                </div>
                            </div>
                            <div className="form-group col-md-4">
                                <div><label htmlFor="departments_id" className="col-sm-12">Department</label></div>
                                <div className="col-sm-12">
                                    <Select
                                        placeholder="Please Choose Department"
                                        options={department_type_option}
                                        onChange={(val) => this.handleSelectorChange(val, 'departments_id')}
                                        value={selectedDepartmentType}
                                        className='react-select-container  checkValidate'
                                        classNamePrefix="react-select" />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="form-group col-md-4">
                                <div><label htmlFor="staff_category_id" className="col-sm-12">Staff Category</label></div>
                                <div className="col-sm-12">
                                    <Select
                                        placeholder="Please Choose Staff Category"
                                        options={staff_category_options}
                                        onChange={(val) => this.handleSelectorChange(val, 'staff_category_id')}
                                        value={selectedStaffCategory}
                                        className='react-select-container  checkValidate'
                                        classNamePrefix="react-select" />
                                </div>
                            </div>
                            <div className="form-group col-md-4">
                                <div><label htmlFor="remark" className="col-sm-12">Remark</label></div>
                                <div className="col-sm-12">
                                    <input
                                        type="text"
                                        id='remark'
                                        className="form-control"
                                        value={data.remark}
                                        onChange={this.handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="form-group col-md-4">
                                <div><label htmlFor="active" className="col-sm-12 text-center">Active</label></div>
                                <div className="col-sm-12">
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 34 }}>
                                        <input
                                            type="checkbox"
                                            id={'active'}
                                            checked={data.active == 0 ? false : true}
                                            onChange={(e) => this.handleCheckChange(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row save-btn">
                            <div className="float-right">
                                {/* this.save.bind(this) */}
                                <button onClick={() => this.handleSave()} className="btn btn-primary" id="saving_button" type="button">Save</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

export default DesignationEdit
